import React from 'react';

function formatValue(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return value ?? '—';
  return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(number);
}

export default function PsyChartTooltip({ active, payload = [], label, valueFormatter }) {
  if (!active || !payload.length) return null;

  return (
    <div className="psy-chart-tooltip">
      {label ? <div className="psy-chart-tooltip__label">{label}</div> : null}
      <div className="psy-chart-tooltip__items">
        {payload.map((entry, index) => (
          <div className="psy-chart-tooltip__item" key={`${entry?.dataKey || entry?.name || 'item'}-${index}`}>
            <span
              className="psy-chart-tooltip__dot"
              style={{ background: entry?.color || entry?.fill || '#5547e8' }}
            />
            <span className="psy-chart-tooltip__name">{entry?.name || entry?.dataKey || 'Valor'}</span>
            <strong>
              {valueFormatter ? valueFormatter(entry?.value, entry) : formatValue(entry?.value)}
            </strong>
          </div>
        ))}
      </div>
    </div>
  );
}
